import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { PlantingSiteSpeciesDto } from 'src/app/models/trofaco/plantingSiteSpeciesDto';
import { PlantingSiteService } from 'src/app/modules/core/services/planting-site.service';
import { ConfirmDeleteModalComponent } from 'src/app/modules/core/components/delete-modal/confirm-delete-modal-component';
import { ArrayHelper } from 'src/app/models/helpers/array-helper';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { speciesDto } from 'src/app/models/trofaco/speciesDto';
import { ModalPlantedTreesComponent } from '../modal-planted-trees/modal-planted-trees/modal-planted-trees.component';
import { CertificateDto } from 'src/app/models/trofaco/certificateDto';

@Component({
  selector: 'app-planted-trees',
  templateUrl: './planted-trees.component.html'
})
export class PlantedTreesComponent implements OnInit {
    @ViewChild(ConfirmDeleteModalComponent, { static: false }) confirmDeleteModal: ConfirmDeleteModalComponent;

    @Input()
    areaTreeSpecies: PlantingSiteSpeciesDto[] = [];

    @Input()
    totalTreeSpecies: PlantingSiteSpeciesDto[] = [];

    @Input()
    totalCertifiedSpecies: CertificateDto[] = []

    @Input()
    totalAmount: number;

    @Input()
    plantingSiteAreaId: string;

    modalRef: BsModalRef;

    @Input()
    speciesDto: speciesDto[];
    treeSpeciesModal : PlantingSiteSpeciesDto;


    private readonly confirmDeleteMsg = "Are you sure you want to delete";

    constructor(private plantingSiteService: PlantingSiteService,
        private _modalService: BsModalService,) { }

    async ngOnInit() {
        this.calculateMiscAmount();
    }

    async saveSpecies(species: PlantingSiteSpeciesDto) {

        const result = await this.plantingSiteService.saveSpecies(species, this.plantingSiteAreaId);
        species.id = result;
        this.areaTreeSpecies.push(species);
        this.totalTreeSpecies.push(species);

        this.calculateMiscAmount();
    }

    async editSpecies(species: PlantingSiteSpeciesDto) {
        await this.plantingSiteService.saveSpecies(species, this.plantingSiteAreaId);
        let index = this.areaTreeSpecies.findIndex(x => x.id == species.id);
        this.areaTreeSpecies[index] = species;
        this.areaTreeSpecies = ArrayHelper.sortBy(this.areaTreeSpecies, true, coll => coll.species);
        this.calculateMiscAmount();
    }

    async delete(species: PlantingSiteSpeciesDto) {
        let result = await this.confirmDeleteModal.showAwait(this.confirmDeleteMsg);
        if (result) {
            await this.plantingSiteService.deleteSpecies(species.id);
            let index = this.areaTreeSpecies.findIndex(x => x.id == species.id);
            this.areaTreeSpecies.splice(index, 1);
            index = this.totalTreeSpecies.findIndex(x => x.id == species.id);
            this.totalTreeSpecies.splice(index, 1);
            this.calculateMiscAmount();
        }
    }
    @Input()
    miscAmount: number;
    private calculateMiscAmount() {
        if (this.totalTreeSpecies === undefined) return false;

        const sumAllSpecies = this.totalTreeSpecies.reduce((sum, current) => sum + +current.count, 0);
        const sumAllCertificate = this.totalCertifiedSpecies.reduce((sum, current) => sum + +current.count, 0);
        // this.miscAmount = this.totalAmount - sumAllCertificate;
        this.miscAmount = sumAllSpecies - sumAllCertificate;
        sessionStorage.setItem('miscAmount_' + this.plantingSiteAreaId ,this.miscAmount.toString());
    }

    async openModal(treeSpecies: PlantingSiteSpeciesDto) {
        this.treeSpeciesModal = { ... treeSpecies };

        const initialState = {
            speciesDto : this.speciesDto,
            misc: this.miscAmount,
            isEditPlantedTree : true,
            plantingSiteAreaId: this.plantingSiteAreaId,
            treeSpecies: this.treeSpeciesModal,
        };

        this.modalRef = this._modalService.show(ModalPlantedTreesComponent, {
            class: "modal-lg",
            initialState,
            keyboard: false,
        });

        this.modalRef.content.isSaved$.subscribe(async (value) => {
            if (value) {

                await this.areaTreeSpecies.splice(this.areaTreeSpecies.findIndex(e => e.id === treeSpecies.id),1,this.treeSpeciesModal);
                await this.totalTreeSpecies.splice(this.totalTreeSpecies.findIndex(e => e.id === treeSpecies.id),1,this.treeSpeciesModal);

                this.calculateMiscAmount();

            }
        });
    }

    totalSpeciesInArea() {
        const sum = this.areaTreeSpecies.reduce((sum, current) => sum + +current.count, 0);
        return sum;
    }

}

